"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACAlert = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ACAlert = function (props) {
    var icons = {
        default: (0, jsx_runtime_1.jsx)("i", { className: "aci aci-info aci-dynamic-size size-5" }),
        primary: (0, jsx_runtime_1.jsx)("i", { className: "aci aci-info aci-dynamic-size size-5" }),
        warning: (0, jsx_runtime_1.jsx)("i", { className: "aci aci-warning-shield" }),
        danger: (0, jsx_runtime_1.jsx)("i", { className: "aci aci-error-shield" }),
    };
    var icon = icons === null || icons === void 0 ? void 0 : icons[(props === null || props === void 0 ? void 0 : props.color) || 'default'];
    return ((0, jsx_runtime_1.jsxs)("div", { className: "apx-ui_alert ".concat((props === null || props === void 0 ? void 0 : props.className) || "", " ").concat((props === null || props === void 0 ? void 0 : props.color) || ''), children: [(0, jsx_runtime_1.jsx)("span", { className: "apx-ui_alert--icon", children: icon }), (0, jsx_runtime_1.jsx)("span", { className: "apx-ui_alert--label", children: props.label })] }));
};
exports.ACAlert = ACAlert;
